angular.module('angus.services').service('tankService', [
    '$http',
    function($http) {

        function getHistoricalUnitsAvailable(subscriberKey,containerKey,params) {
            return $http.get(`api/subscriber/${subscriberKey}/containers/${containerKey}/historical-units-available`,{apiV2: true, params})
                .then(function(res){
                    return res.data;
                });
        }

        function getContainers(subscriberKey,containerKeys) {
            return $http.get(`api/subscriber/${subscriberKey}/containers`,{params:{containerKeys},apiV2: true})
                .then(function(res){
                    return res.data;
                });
        }

        return {
            getHistoricalUnitsAvailable,
            getContainers
        };
    }
])